<template>
    <div>
        <QueryInput v-model="store.searchQuery" />

        <div class="tags">
            <Checkbox2 class="mr-2" v-model="store.showOutdatedBrackets">
                {{ translate("admin_bracket_listing.show_outdated_brackets") }} ({{ store.totalOutdatedBrackets }})
            </Checkbox2>

            <Checkbox2 v-model="store.showDisqualifiedBrackets">
                {{ translate("admin_bracket_listing.show_brackets_with_DQ") }} ({{ store.bracketsWithDisqualifications }})
            </Checkbox2>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../../Common/translations";
    import QueryInput from "../../Common/QueryInput.vue";
    import Checkbox2 from "../../Common/Checkbox2.vue";
    import { useBracketsListingStore } from "./bracketsListingApp";

    const store = useBracketsListingStore();
</script>

<style scoped></style>
